import type { StaticLayerPayload } from "@config";
import { ChartLibrary } from "@library-elements/chart";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: ChartLibrary,
};

export const Chart = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
